import { render, staticRenderFns } from "./TheActivityInfoBox.vue?vue&type=template&id=bb8d90a4&scoped=true"
import script from "./TheActivityInfoBox.vue?vue&type=script&lang=js"
export * from "./TheActivityInfoBox.vue?vue&type=script&lang=js"
import style0 from "./TheActivityInfoBox.vue?vue&type=style&index=0&id=bb8d90a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb8d90a4",
  null
  
)

export default component.exports